import type { App, DirectiveBinding } from 'vue';

import { makeInlineBackgroundsReadable, stripNbsp } from '@/utils/html';

const render = (el: HTMLElement, html: string): void => {
  el.innerHTML = stripNbsp(html);
  makeInlineBackgroundsReadable(el);
};

const normalizeHtmlDirective = {
  mounted (el: HTMLElement, binding: DirectiveBinding): void {
    render(el, binding.value);
  },
  updated (el: HTMLElement, binding: DirectiveBinding): void {
    if (binding.value !== binding.oldValue) {
      render(el, binding.value);
    }
  },
  unmounted (el: HTMLElement): void {
    el.innerHTML = '';
  },
};

export const registerNormalizeHtmlDirective = (app: App): void => {
  app.directive('normalize-html', normalizeHtmlDirective);
};
